import { render, staticRenderFns } from "./CourseManaCard.vue?vue&type=template&id=39150f18"
import script from "./CourseManaCard.vue?vue&type=script&lang=js"
export * from "./CourseManaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports